<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
  >
    <template #header>选择商品</template>
    <template #content>
      <app-filter-group :reset="false">
        <gj-category-select
            multiple
            v-model="category"
            :collapse-tags="true"
            placeholder="全部品类"
            width="150px"
            style="margin-right: 10px"
        >
        </gj-category-select>
        <gj-select-input
          v-model="keyword"
          :options="[
              {id: 'asin', text: 'ASIN'},
              {id: 'parentAsin', text: '父ASIN'},
              {id: 'msku', text: 'MSKU'},
              {id: 'sku', text: 'SKU'},
              {id: 'productName', text: '产品名称'},
          ]"
        >
        </gj-select-input>
      </app-filter-group>
      <div>
        <gj-table
          :data="data"
          :columns="columns"
          selection
          :offset-height="85"
        >
          <template></template>
        </gj-table>
      </div>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="confirm" type="primary">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn, selectionMixin} from "../../../../../minxins";

    export default {
        name: "sharing-add-goods",
        mixins: [modalMixIn, selectionMixin],
        data() {
            return {
                category: null,
                keyword: {
                    key: 'asin',
                    value: null,
                },
                data: [
                    {}
                ],
                columns: [
                    {id: 'market', header: '店铺/国家', field: 'marketName', minWidth: '120px',},
                    {id: 'picture', header: '图片', field: 'picture:picture', minWidth: '60px',},
                    {id: 'listingInfo', header: '商品标题/ASIN/MSKU', field: 'slot:listingInfo', minWidth: '250px',},
                    {id: 'price', header: '原价/优惠价', field: 'slot:price', minWidth: '120px'},
                    {id: 'sales', header: '销量', field: 'sales', minWidth: '120px',},
                    {id: 'salesAmount', header: '销售额', field: 'salesAmount', minWidth: '120px',},
                ]
            }
        }
    }
</script>

<style scoped>

</style>
